module.exports = __webpack_public_path__ + "img/zafir.5ca6a65e.png";